import IRequest from "../../IRequest"

export type TCaixaBancoContas = {
    codigo: number,
    nome: string,
    id: number,
    tipo_conta: string,
    sistema_xy: string,
    saldo: number
}

export interface ICaixaBancoContas {
    reqBancos: IRequest<TCaixaBancoContas>,
    dataBancos: TCaixaBancoContas[]
}

export const defValueCaixaBancoConta: TCaixaBancoContas = {
    codigo: 0,
    nome: "",
    id: 0,
    tipo_conta: "",
    sistema_xy: "",
    saldo: 0
}
